import { Button, Heading, Stack, Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function EmailView() {
  return (
    <Stack spacing={4} py={2} px={4} flex="1 0 auto" minHeight="500px">
      <Heading>Email</Heading>
      <Link as={RouterLink} to="/quiz-results">
        <Button isFullWidth colorScheme="blue">
          Next
        </Button>
      </Link>
    </Stack>
  );
}

export default EmailView;
